import { Controller } from '@hotwired/stimulus'
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['user', 'form']

  connect() {
    this.element.addEventListener(
      'requestSubmit', () => {
        console.log("submitting")
        //this.element.requestSubmit()
        //Rails.fire(this.element, 'submit')
        Turbo.navigator.submitForm(this.element)
      }
    )
  }
}
